module.exports = __webpack_public_path__ + "static/neuro-psychology-room-db12c5c26af9e20385aa8ef91df74c56.jpg";